
import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";
import ConferenceManagement from "@/views/ConferenceView/ConferenceManagement.vue";

const conferenceMenu = {
  path: "/conferences",
  component: DashboardLayout,
  redirect: "/conferences",
  name: "conferences",
  children: [
    {
      path: "",
      name: "conferences-management",
      components: { default: ConferenceManagement },
      meta: { requiresAuth: true, requiredRoles: ["content", 'master'], title: "컨퍼런스 관리" },
    },
  ],
};

export default conferenceMenu;
